<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :dir="dir"
    :value="value"
    :multiple="multiple"
    :loading="loading"
    ref="innerVSelect"
  >
    <template #no-options> هیچ گزینه‌ای پیدا نشد. </template>
    <template #searchPlaceholder> در حال جستجو... </template>
    <slot>
      <!-- Allows for other custom slots to be passed through -->
    </slot>
  </v-select>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: { vSelect },
  inheritAttrs: false, // This makes sure $attrs are applied to v-select, not the root element
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dir: {
      type: String,
      default: "rtl", // Default direction
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    // the value prop should exist in order to make v-validate work
    value: {},
  },
  methods: {
    clearSelection() {
      // Directly call clearSelection on the v-select component
      this.$refs.innerVSelect.clearSelection();
    },
  },
};
</script>
